
export const GET_PROFILO = "GET_PROFILO"
export const GET_PROFILO_SUCCESS = "GET_PROFILO_SUCCESS"

export const POST_PROFILO = "POST_PROFILO"
export const POST_PROFILO_SUCCESS = "POST_PROFILO_SUCCESS"


export const PATCH_PROFILO = "PATCH_PROFILO"
export const PATCH_PROFILO_SUCCESS = "PATCH_PROFILO_SUCCESS"

export const GET_PRESA_VISIONE = "GET_PRESA_VISIONE"
export const GET_PRESA_VISIONE_SUCCESS = "GET_PRESA_VISIONE_SUCCESS"

export const GET_ULTIMA_INFORMATIVA = "GET_ULTIMA_INFORMATIVA"
export const GET_ULTIMA_INFORMATIVA_SUCCESS = "GET_ULTIMA_INFORMATIVA_SUCCESS"

export const PRE_PRESA_VISIONE = "PRE_PRESA_VISIONE"

export const POST_PRESA_VISIONE = "POST_PRESA_VISIONE"
export const POST_PRESA_VISIONE_SUCCESS = "POST_PRESA_VISIONE_SUCCESS"

export const GET_AVVISI_UTENTE = "GET_AVVISI_UTENTE"
export const GET_AVVISI_UTENTE_SUCCESS = "GET_AVVISI_UTENTE_SUCCESS"

export const RESET_PROFILAZIONE_STATE = "RESET_PROFILAZIONE_STATE"



